// extracted by mini-css-extract-plugin
export var addButton = "_g9-0";
export var border = "_g9-8";
export var check = "_g9-h";
export var danger = "_g9-6";
export var dropdownContainer = "_g9-1";
export var editModalBody = "_g9-j";
export var footerContainer = "_g9-i";
export var fullWidth = "_g9-a";
export var hide = "_g9-9";
export var icon = "_g9-3";
export var input = "_g9-7";
export var inputFlex = "_g9-b";
export var inputWrapper = "_g9-c";
export var manualFocus = "_g9-5";
export var optionButton = "_g9-4";
export var pillWrapper = "_g9-e";
export var pointer = "_g9-2";
export var showOverflow = "_g9-f";
export var tagsFlex = "_g9-d";
export var xButton = "_g9-g";